// src/pages/Culture.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useData } from "../context/DataProvider";

const Culture = () => {
   const { articles, loading } = useData();

   if (loading) {
      return <div className="p-8">Жүктелуде...</div>;
   }

   // Фильтруем статьи по CategoryID=2
   const cultureArticles = articles.filter((article) => article.CategoryID === "2");

   return (
      <div>
         {/* Шапка (Hero) */}
         <header className="relative bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8 mb-8">
            <div
               className="absolute inset-0 bg-cover bg-center opacity-60"
               style={{
                  backgroundImage:
                     "url('https://images.unsplash.com/photo-1580210723492-9930551dbdf2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDR8fGN1bHR1cmUlMjB2aWJlc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1400&q=60')",
               }}
            />
            <div className="relative max-w-5xl mx-auto">
               <h1 className="text-4xl sm:text-5xl font-bold mb-2">Мәдениет</h1>
               <p className="text-lg text-gray-200 max-w-2xl">
                  Ұлттық өнер мен заманауи мәдениет саласындағы соңғы жаңалықтар, фестивальдер, шығармашылық жобалар және руханият
                  төңірегіндегі тың бастамалар жайлы білуге шақырамыз.
               </p>
            </div>
         </header>

         {/* Негізгі контент */}
         <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Описание раздела */}
            <section className="mb-8">
               <h2 className="text-2xl font-bold mb-4">Қош келдіңіздер!</h2>
               <p className="mb-4">
                  Мәдениет – ұлттың рухани байлығы мен келбетін айқындайтын маңызды сала. Осы бөлімде сіздер өнер, музыка, театр,
                  кино, әдебиет және көптеген шығармашылық бағыттардағы жаңалықтар мен мақалаларды таба аласыздар.
               </p>
               <p>
                  Ұлттық дәстүрлерді дәріптеу мен заманауи өнерді дамытуда атқарылып жатқан шаралар, танымал өнер иелерінің
                  сұхбаттары мен өнертанушылардың ой-пікірлері де назарларыңызға ұсынылады. Мәдениетімізді бірге танып,
                  өркендетуге ат салысайық!
               </p>
            </section>

            {/* Карточки новостей (CategoryID=2) */}
            <section>
               <h2 className="text-xl font-bold mb-4">Мәдениет жаңалықтары</h2>

               {/* Если статей нет */}
               {cultureArticles.length === 0 ? (
                  <p>Мәдениет санатында жаңалықтар жоқ</p>
               ) : (
                  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                     {cultureArticles.map((article) => (
                        <CultureCard key={article.ID} article={article} />
                     ))}
                  </div>
               )}
            </section>
         </main>
      </div>
   );
};

/* Карточка одной новости */
function CultureCard({ article }) {
   const { ID, Title, Category, Date, ImageUrl } = article;

   return (
      <article className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
         <img
            src={ImageUrl || "https://via.placeholder.com/400x300"}
            alt={Title}
            className="w-full h-48 object-cover rounded-t-lg"
         />
         <div className="p-4">
            <p className="text-xs text-gray-500 mb-1">
               {Category} &mdash; {Date}
            </p>
            <h3 className="text-base font-semibold text-gray-800 mb-2 line-clamp-2">{Title}</h3>
            <Link to={`/news/${ID}`} className="text-sm text-blue-600 hover:underline">
               Толықтай оқу
            </Link>
         </div>
      </article>
   );
}

export default Culture;
